// Core
import { executeRequest } from '@/core/either';
import { http } from '@/core/api';

// Types
import type { ApiResult } from '@/core/either';
import type { IPutPinByWorkflow } from '../types/pin.type';

export const pinAuthService = {
  createPin(pin: string): Promise<ApiResult<unknown>> {
    return executeRequest(() =>
      http.post('auth-server/b2b/pin', {
        pin,
      })
    );
  },
  /**
   * Cambia o resetea el PIN autorizado por un workflow de verificación de identidad, sin OTP.
   * `oldPin` es opcional: el reseteo manda `businessFlow` y no envía `authType` ni `authValue`.
   *
   * @returns resultado de la actualización del PIN
   */
  updatePinByWorkflow(data: IPutPinByWorkflow): Promise<ApiResult<void>> {
    return executeRequest(() => http.put<void>('auth-server/b2b/pin', data));
  },
};
